const sanitizeFactory = (fn: (values: { [key: string]: any }, key: string) => boolean) => {
    return <T extends { [k in keyof T]: any }>(values: T): T => {
        const shallowCopy: { [key: string]: any } = { ...values };

        Object.keys(shallowCopy).forEach(key => {
            if (fn(shallowCopy, key)) {
                delete shallowCopy[key as string];
            }
        });

        return shallowCopy as T;
    };
};

const sanitizeNullables = sanitizeFactory((values, key) => typeof values[key] === 'undefined');
const sanitizeEmptyStrings = sanitizeFactory((values, key) => {
    const potentialString = values[key];
    if (typeof potentialString === 'string') {
        return potentialString.length === 0;
    }

    return false;
});

export { sanitizeEmptyStrings, sanitizeNullables };
